import { apiClient } from "src/careflow/ph-core/api_client/api_client";

const apiBase = 'nat/request';

const RequestApi = {

  createRequest: async (payload: any) => {
    return apiClient.post<any, undefined>(
      `${apiBase}/`, payload
    );
  },

  updateRequest: async (patientId: string): Promise<any | undefined> => {
    return apiClient.put<any, undefined>(
      `${apiBase}/${patientId}`, undefined
    );
  }
}

export const RequestService = {

  createRequest: async (payload: any): Promise<any | undefined> => {
    const response = await RequestApi.createRequest(payload);
    if (!response) return undefined;
    return response;
  },

  updateRequest: async (patientId: string): Promise<any | undefined> => {
    const response = await RequestApi.updateRequest(patientId);
    if (!response) return undefined;
    return response;
  }

}
